import { render, staticRenderFns } from "./BeeMaterialAutocomplete.vue?vue&type=template&id=687b4abb"
import script from "./BeeMaterialAutocomplete.vue?vue&type=script&lang=js"
export * from "./BeeMaterialAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports